<template>
    <div class="entry-content">
        <h2>Information</h2>
        <form @submit.prevent="handleFormSubmit">
            <input type="text" v-model="name" placeholder="Lesson Name" maxlength="400" required>
            <input type="number" min="1" v-model="order" placeholder="Lesson Order" required>
            <div class="form-footer-wrapper">
                <div class="left-wrapper">
                    <button type="button" class="cancel delete" @click.prevent="handleDelete">Delete Lesson</button>
                </div>
                <div class="right-wrapper">
                    <button type="button" class="cancel" @click.prevent="handleRedirect">Cancel</button>
                    <input type="submit" class="save" value="Save" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CheckApi from '@/api'

export default {
    name: 'Edit Lesson',
    data() {
		return {
            name: '',
            order: ''
        }
    },
    mounted() {
        this.fetchLessonTemplate()
    },
    methods: {
        async fetchLessonTemplate() {
            const response = await CheckApi.getLessonTemplateById(this.$route.params.lessonTemplateId)
            const {
                name,
                orderNumber
            } = response.data.data
            this.name = name
            this.order = orderNumber
        },
        async handleFormSubmit() {
            await CheckApi.updateLessonTemplateById({name: this.name, lessonTemplateId: parseInt(this.$route.params.lessonTemplateId), orderNumber: this.order})
            this.$router.go(-1)
        },
        handleRedirect() {
            this.$router.go(-1)
        },
        async handleDelete() {
            await CheckApi.handleLessonTemplateDelete(this.$route.params.lessonTemplateId)
            this.handleRedirect()
        }
    }
}
</script>

<style lang="scss" scoped>

.form-footer-wrapper {
        display: flex;
        justify-content: space-between;

    .right-wrapper {
        display: flex;
    }
}

.cancel {
    background-color: transparent;
    border: .0625em solid #141638;

    &.delete {
        background-color: #ff8900;
        width: 150px !important;
        color: white;
        border: none;

        &:hover {
            color: white;
        }
    }

    &:hover {
        color: #141638;
    }
}

.form-footer-wrapper {
        display: flex;
    }

    .cancel {
        background-color: transparent;
        border: .0625em solid #141638;

        &:hover {
            color: #141638;
        }
    }

    .cancel,
    .save {
        width: 100px !important;
        height: 30px !important;
        border-radius: .75em !important;
        text-align: center !important;
        cursor: pointer;
    }

    .save {
        margin-left: 15px;
        background-color: #08ce97;
        border-style: none;
        color: #fff;
        border-radius: 0.75em;
        display: block !important;
        margin: 0 !important;
        margin-left: 15px !important;
        padding: 5px;
    }
</style>